import { render } from "./NavSubItem.vue?vue&type=template&id=74c791af&scoped=true&ts=true"
import script from "./NavSubItem.vue?vue&type=script&lang=ts"
export * from "./NavSubItem.vue?vue&type=script&lang=ts"

import "./NavSubItem.vue?vue&type=style&index=0&id=74c791af&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c791af"]])

export default __exports__